import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';

export const DISPLAY_SNAP_LINE_DEBUG_CONTENT_KEY = '__displaySnapLineDebugContent__';

export function shouldDisplayDebugContent() {
    return (ENV.IS_TEST || __IS_DEV__)
        // @ts-ignore
        && window[DISPLAY_SNAP_LINE_DEBUG_CONTENT_KEY];
}
